<template>
  <div class="card card-stats">
    <div class="card-body">
      <div class="row">
        <div class="col-5 col-md-4">
          <slot name="header">
            <div class="icon-big text-center"
                 :class="`text-${type}`">
              <i :class="icon"></i>
            </div>
          </slot>
        </div>
        <div class="col-7 col-md-8">
          <slot name="content">
            <div class="numbers">
              <p class="card-category">{{smallTitle}}</p>
              <p class="card-title">{{title}}</p>
            </div>
          </slot>
          <slot name="content" v-if="title2">
            <div class="numbers">
              <p class="card-category">{{smallTitle2}}</p>
              <p class="card-title">{{title2}}</p>
            </div>
          </slot>
          <slot name="content" v-if="title3">
            <div class="numbers">
              <p class="card-category">{{smallTitle3}}</p>
              <p class="card-title tittle3">{{title3}}</p>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <!-- <div class="card-footer">
      <hr/>
      <slot name="footer"></slot>
    </div> -->

  </div>
</template>
<script>
  export default {
    name: 'stats-card',
    props:{
      type: {
        type: String,
        description: 'Card text type (primary|info|danger|default|warning|success)'
      },
      title: {
        type: String,
        description: 'Card title'
      },
      smallTitle: {
        type: String,
        description: 'Card small title'
      },
      title2: {
        type: String,
        description: 'Card title'
      },
      smallTitle2: {
        type: String,
        description: 'Card small title'
      },
      title3: {
        type: String,
        description: 'Card title'
      },
      smallTitle3: {
        type: String,
        description: 'Card small title'
      },
      icon: {
        type: String,
        description: 'Card icon'
      }
    }
  }

</script>
<style scoped>
  .card-body{
    min-height: 125px!important;
  }
  .card-title{
    margin-top: 4px;
    padding-bottom: 15px;
    font-size: 0.9em;
  }
  .card-title.tittle3{
    font-size: 0.6em;
  }

  .col{
    padding-right: 10px;
    padding-left: 0px;
  }

</style>
